import { EntityListTypeName } from '@ydistri/api-sdk';
import { ProjectAdministrationSubpage } from '../../../projectAdministrationLib';
import { SkuEntityListSpecification } from './SkuEntityListSpecification';

export class SourceEntityListSpecification extends SkuEntityListSpecification {
  constructor() {
    super(
      ProjectAdministrationSubpage.SOURCELISTS,
      'Source list administration',
      'Source list',
      'Source lists',
      'SRC',
      [EntityListTypeName.Target, EntityListTypeName.Forced],
    );
  }
}
